import { CompanySizeTierEnum, LevelOfExperienceEnum } from '../consts/enums';
import {
  ReferralEligibility,
  ReferralForceSendOutcome,
  ReferralIneligibilityReason,
  ReferralPath,
  ReferralPositionEndReason,
  ReferralRewardFallbackReason,
  ReferralRewardStatus,
  ReferralStatus,
} from '../enums/referral.enum';

export const STRING_KEYS = {
  CONVERSATION: 'CONVERSATION',
  PREVIEW: 'PREVIEW',
  REMOTE: 'REMOTE',
  SPECIFIC_COUNTRY_REMOTE: 'SPECIFIC_COUNTRY_REMOTE',
  US_UK_COUNTRY_REMOTE: 'US_UK_COUNTRY_REMOTE',
  LOGIN_TITLE: 'LOGIN_TITLE',
  LOGIN_DESCRIPTION: 'LOGIN_DESCRIPTION',
  LOGIN_BUTTON: 'LOGIN_BUTTON',
  LOGIN_EMAIL_LABEL: 'LOGIN_EMAIL_LABEL',
  LOGIN_PASSWORD_LABEL: 'LOGIN_PASSWORD_LABEL',
  LOGIN_EMAIL_VALIDATION: 'LOGIN_EMAIL_VALIDATION',
  LOGIN_EMAIL_REQUIRED_VALIDATION: 'LOGIN_EMAIL_REQUIRED_VALIDATION',
  LOGIN_PASSWORD_REQUIRED_VALIDATION: 'LOGIN_PASSWORD_REQUIRED_VALIDATION',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LAYOUT_HOME_TITLE: 'LAYOUT_HOME_TITLE',
  LAYOUT_OPS_POSITIONS_TITLE: 'LAYOUT_OPS_POSITIONS_TITLE',
  LAYOUT_OPS_ACCOUNTS_TITLE: 'LAYOUT_OPS_ACCOUNTS_TITLE',
  LAYOUT_SALES_TITLE: 'LAYOUT_SALES_TITLE',
  LAYOUT_POSITION_TITLE: 'LAYOUT_POSITION_TITLE',
  LAYOUT_TALENTS_TITLE: 'LAYOUT_TALENTS_TITLE',
  LAYOUT_ACCOUNTS_TITLE: 'LAYOUT_ACCOUNTS_TITLE',
  LAYOUT_AI_TITLE: 'LAYOUT_AI_TITLE',
  OPS_POSITIONS_PAGE_TITLE: 'OPS_POSITIONS_PAGE_TITLE',
  OPS_POSITIONS_PAGE_DOWNLOAD_CSV_TITLE: 'OPS_POSITIONS_PAGE_DOWNLOAD_CSV_TITLE',
  POSITIONS_PAGE_TITLE: 'POSITIONS_PAGE_TITLE',
  POSITIONS_DETAILS_PAGE_TITLE_NAV: 'POSITIONS_DETAILS_PAGE_TITLE_NAV',
  POSITIONS_PAGE_CREATE_BUTTON: 'POSITIONS_PAGE_CREATE_BUTTON',
  POSITIONS_LIST_FILTER_ACCOUNT: 'POSITIONS_LIST_FILTER_ACCOUNT',
  POSITIONS_LIST_FILTER_STATUS: 'POSITIONS_LIST_FILTER_STATUS',
  POSITIONS_LIST_FILTER_PRICING_PLAN: 'POSITIONS_LIST_FILTER_PRICING_PLAN',
  POSITIONS_LIST_FILTER_STATE: 'POSITIONS_LIST_FILTER_STATE',
  POSITIONS_LIST_TABLE_HEADER_TITLE: 'POSITIONS_LIST_TABLE_HEADER_TITLE',
  POSITIONS_LIST_TABLE_HEADER_ACCOUNT: 'POSITIONS_LIST_TABLE_HEADER_ACCOUNT',
  POSITIONS_LIST_TABLE_HEADER_LOCATION:
    'POSITIONS_LIST_TABLE_HEADER_LOCATION',
  POSITIONS_LIST_TABLE_HEADER_MATCHES: 'POSITIONS_LIST_TABLE_HEADER_MATCHES',
  //
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_TITLE: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_TITLE',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_ACCOUNT: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_ACCOUNT',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_LAST_PUBLISHED: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_LAST_PUBLISHED',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_PUBLISHED: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_PUBLISHED',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_ACCEPTANCE: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_ACCEPTANCE',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_TO_REVIEW: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_TO_REVIEW',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_APPROVED: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_APPROVED',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_DECLINED: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_DECLINED',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_CONTACTED: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_CONTACTED',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_REPLIED: 'ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_REPLIED',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_UPDATED: 'POSITIONS_LIST_TABLE_HEADER_UPDATED',
  ACTIVE_ACCOUNTS_POSITIONS_LIST_TABLE_HEADER_CREATED: 'POSITIONS_LIST_TABLE_HEADER_CREATED',
  //
  LINKEDIN_VALIDATION: 'LINKEDIN_VALIDATION',
  POSITIONS_LIST_TABLE_HEADER_STATUS: 'POSITIONS_LIST_TABLE_HEADER_STATUS',
  POSITIONS_LIST_TABLE_HEADER_UPDATED: 'POSITIONS_LIST_TABLE_HEADER_UPDATED',
  POSITIONS_LIST_TABLE_HEADER_CREATED: 'POSITIONS_LIST_TABLE_HEADER_CREATED',
  CREATE_TALENT_MANUALLY: 'CREATE_TALENT_MANUALLY',
  ACCOUNT_STATUSES: {
    ['ACTIVE' as string]: 'ACCOUNT_STATUSES_PUBLISHED',
    ['INACTIVE' as string]: 'ACCOUNT_STATUSES_DRAFT',
    ['DEACTIVATED' as string]: 'ACCOUNT_STATUSES_DRAFT',
    ['ONBOARDING' as string]: 'ACCOUNT_STATUSES_ONBOARDING',
    ['SUSPENDED' as string]: 'ACCOUNT_STATUSES_SUSPENDED',
  },
  POSITION_STATUSES: {
    ['PUBLISHED' as string]: 'POSITION_STATUSES_PUBLISHED',
    ['DRAFT' as string]: 'POSITION_STATUSES_DRAFT',
    ['DELETED' as string]: 'POSITION_STATUSES_DELETED',
  },
  POSITION_STATES: {
    ['OPEN' as string]: 'POSITION_STATES_OPEN',
    ['CLOSED' as string]: 'POSITION_STATES_CLOSED',
  },
  MATCH_STATUSES: {
    ['PUBLISHED' as string]: 'MATCH_STATUS_PUBLISHED',
    ['DRAFT' as string]: 'MATCH_STATUS_DRAFT',
    ['DELETED' as string]: 'MATCH_STATUS_DELETED',
    ['ARCHIVED' as string]: 'MATCH_STATUS_ARCHIVED',
  },
  ENGAGEMENT_STATUS: {
    ['PENDING_REVIEW' as string]: 'ENGAGEMENT_STATUS_PENDING_REVIEW',
    ['ENGAGED' as string]: 'ENGAGEMENT_STATUS_ENGAGED',
    ['DECLINED' as string]: 'ENGAGEMENT_STATUS_DECLINED',
  },
  REJECTED_REASON_TITLE: 'REJECTED_REASON_TITLE',
  REJECTED_REASONS: {
    ['OVERQUALIFIED' as string]: 'REJECTED_REASONS_OVERQUALIFIED',
    ['INSUFFICIENT_EXPERIENCE' as string]: 'REJECTED_REASONS_INSUFFICIENT_EXPERIENCE',
    ['LOCATION' as string]: 'REJECTED_REASONS_LOCATION',
    ['RELEVANT_SKILLS' as string]: 'REJECTED_REASONS_RELEVANT_SKILLS',
    ['RELEVANT_EDUCATION' as string]: 'REJECTED_REASONS_RELEVANT_EDUCATION',
    ['OTHER' as string]: 'REJECTED_REASONS_OTHER',
    ['RECENT_ROLE_CHANGE' as string]: 'REJECTED_REASONS_RECENT_ROLE_CHANGE',
    ['BROKEN_LINK' as string]: 'REJECTED_REASONS_MENU_BROKEN_LINK',
    ['IRRELEVANT_TITLE' as string]: 'REJECTED_REASONS_IRRELEVANT_TITLE',
    ['IRRELEVANT_COMPANIES' as string]: 'REJECTED_REASONS_IRRELEVANT_COMPANIES',
    ['UNSPECIFIED' as string]: 'REJECTED_REASONS_UNSPECIFIED',
  },
  TALENT_LIST_FILTER_CURRENT_COMPANY: 'TALENT_LIST_FILTER_CURRENT_COMPANY',
  TALENT_LIST_FILTER_CURRENT_POSITION: 'TALENT_LIST_FILTER_CURRENT_POSITION',
  FILTER_EMPTY: 'FILTER_EMPTY',
  FILTER_LABEL_ACCOUNT: 'FILTER_LABEL_ACCOUNT',
  FILTER_LABEL_TITLE: 'FILTER_LABEL_TITLE',
  FILTER_LABEL_STATUS: 'FILTER_LABEL_STATUS',
  FILTER_LABEL_STATE: 'FILTER_LABEL_STATE',
  FILTER_LABEL_TALENTS_CURRENT_COMPANY:
    'FILTER_LABEL_TALENTS_CURRENT_COMPANY',
  FILTER_LABEL_TALENTS_TITLE: 'FILTER_LABEL_TALENTS_TITLE',
  FILTER_LABEL_TALENTS_POSITION: 'FILTER_LABEL_TALENTS_POSITION',
  SEARCH_INPUT_PLACEHOLDER: 'SEARCH_INPUT_PLACEHOLDER',
  TALENT_EDITOR_BREADCRUMBS_TITLE: 'TALENT_EDITOR_BREADCRUMBS_TITLE',
  TABLE_ROW_NO_RESULT: 'TABLE_ROW_NO_RESULT',
  POSITION_TABLE_ROW_RESULT_COUNT: 'POSITION_TABLE_ROW_RESULT_COUNT',
  MATCH_TABLE_ROW_RESULT_COUNT: 'MATCH_TABLE_ROW_RESULT_COUNT',
  TALENTS_ERROR: 'TALENTS_ERROR',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  DELETE: 'DELETE',
  TALENTS_ACTION_MENU_HISTORY: 'TALENTS_ACTION_MENU_HISTORY',
  ID: 'ID',
  LAST_CHANGED_BY: 'LAST_CHANGED_BY',
  CREATED_BY_AT: 'CREATED_BY_AT',
  UPDATED_BY_AT: 'UPDATED_BY_AT',
  UNKNOWN: 'UNKNOWN',
  VERSION: 'VERSION',
  SAVE_CHANGES: 'SAVE_CHANGES',
  NEW_TALENT: 'NEW_TALENT',
  NEW_MATCH: 'NEW_MATCH',
  TALENTS_PAGE_CREATE_BUTTON: 'TALENTS_PAGE_CREATE_BUTTON',
  TALENTS_PAGE_TITLE: 'TALENTS_PAGE_TITLE',
  TALENTS_PAGE_EDIT_BREADCRUMBS_TITLE: 'TALENTS_PAGE_EDIT_BREADCRUMBS_TITLE',
  TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_FIRSTNAME: 'TALENT_FIRST_NAME',
  TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_LASTNAME: 'TALENT_LAST_NAME',
  TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_EMAIL: 'TALENT_LAST_EMAIL',
  TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_PHONE: 'TALENTS_PHONE',
  TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_CITY: 'TALENTS_CITY',
  TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_STATE: 'TALENTS_STATE',
  TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_COUNTRY: 'TALENTS_COUNTRY',
  TALENTS_EDIT_BASIC_DETAILS_TITLE: 'TALENTS_EDIT_BASIC_DETAILS_TITLE',
  TALENTS_EDIT_BASIC_DETAILS_VALIDATION: {
    FIRSTNAME: 'FIRSTNAME',
    LASTNAME: 'LASTNAME',
    EMAIL_INVALID: 'EMAIL_INVALIDL',
    EMAIL_REQIRED: 'EMAIL_REQIRED',
    PHONE: 'PHONE',
    COUNTRY: 'COUNTRY',
    CITY: 'CITY',
    STATE: 'STATE',
  },
  BASIC_DETAILS: 'BASIC_DETAILS',
  SOCIAL_LINKS: 'SOCIAL_LINKS',
  INSIGHTS: 'INSIGHTS',
  WHY_HIM: 'WHY_HIM',
  EXPERIENCE: 'EXPERIENCE',
  EDUCATION: 'EDUCATION',
  TITLE_LOGO: 'TITLE_LOGO',
  TITLE_LABEL: 'TITLE_LABEL',
  TITLE_EXPERIENCE: 'TITLE_EXPERIENCE',
  TITLE_EDUCATION: 'TITLE_EDUCATION',
  ADD_NEW_CHAPTER_EXPERIENCE: 'ADD_NEW_CHAPTER_EXPERIENCE',
  ADD_NEW_CHAPTER_EDUCATION: 'ADD_NEW_CHAPTER_EDUCATION',
  ADD_NEW_SOCIAL_LINK: 'ADD_NEW_SOCIAL_LINK',
  START_DATE_TITLE: 'START_DATE_TITLE',
  END_DATE_TITLE: 'END_DATE_TITLE',
  LABEL_YEAR: 'LABEL_YEAR',
  LABEL_MONTH: 'LABEL_MONTH',
  PLACEHOLDER_MONTH: 'PLACEHOLDER_MONTH',
  PLACEHOLDER_YEAR: 'PLACEHOLDER_YEAR',
  CURRENT: 'CURRENT',
  COMPANY: 'COMPANY',
  EDUCATION_INSTITUTE: 'EDUCATION_INSTITUTE',
  TITLE_ROLE: 'TITLE_ROLE',
  EMPTY_AVATAR: 'EMPTY_AVATAR',
  ADD_NEW_MATCH: 'ADD_NEW_MATCH',
  POSITION_DETAILS_SUB_TITLE_CREATE: 'POSITION_DETAILS_SUB_TITLE_CREATE',
  POSITION_DETAILS_SUB_TITLE_UPDATE: 'POSITION_DETAILS_SUB_TITLE_UPDATE',
  POSITIONS_DETAILS_CREATE_MATCH_BUTTON: 'POSITIONS_DETAILS_CREATE_MATCH_BUTTON',
  POSITIONS_DETAILS_FILTER_MATCH_STATUS: 'POSITIONS_DETAILS_FILTER_MATCH_STATUS',
  POSITIONS_DETAILS_FILTER_ENGAGE_STATUS: 'POSITIONS_DETAILS_FILTER_ENGAGE_STATUS',
  POSITIONS_DETAILS_TABLE_HEADER_TITLE: 'POSITIONS_DETAILS_TABLE_HEADER_TITLE',
  POSITIONS_DETAILS_TABLE_HEADER_POSITION: 'POSITIONS_DETAILS_TABLE_HEADER_POSITION',
  POSITIONS_DETAILS_TABLE_HEADER_MATCH: 'POSITIONS_DETAILS_TABLE_HEADER_MATCH',
  POSITIONS_DETAILS_TABLE_HEADER_ENGAGEMENT: 'POSITIONS_DETAILS_TABLE_HEADER_ENGAGEMENT',
  POSITIONS_DETAILS_TABLE_HEADER_DATE: 'POSITIONS_DETAILS_TABLE_HEADER_DATE',
  POSITIONS_DETAILS_TABLE_EDIT_MATCH_ACTION: 'POSITIONS_DETAILS_TABLE_EDIT_MATCH_ACTION',
  POSITIONS_DETAILS_TABLE_EDIT_TALENT_ACTION: 'POSITIONS_DETAILS_TABLE_EDIT_TALENT_ACTION',
  POSITIONS_DETAILS_TABLE_PREVIEW_ACTION: 'POSITIONS_DETAILS_TABLE_PREVIEW_ACTION',
  POSITIONS_DETAILS_TABLE_DELETE_ACTION: 'POSITIONS_DETAILS_TABLE_DELETE_ACTION',
  POSITIONS_DETAILS_TABLE_VIEW_ACTIVITY_ACTION: 'POSITIONS_DETAILS_TABLE_VIEW_ACTIVITY_ACTION',
  POSITIONS_DETAILS_TABLE_VIEW_MATCH_ACTION: 'POSITIONS_DETAILS_TABLE_VIEW_MATCH_ACTION',
  NOVICE: 'NOVICE',
  EXPERT: 'EXPERT',
  ADD_ANOTHER: 'ADD_ANOTHER',
  SKILLS: 'SKILLS',
  COMPANY_BACKGROUND: 'COMPANY_BACKGROUND',
  LOCATION_REGIONS: 'LOCATION_REGIONS',
  EXACT_LOCATIONS: 'EXACT_LOCATIONS',
  MULTI_SELECT: {
    RESULTS: 'MULTI_SELECT_RESULTS',
    NO_RESULTS: 'MULTI_SELECT_NO_RESULTS',
    SEARCH_PLACEHOLDER: 'MULTI_SELECT_SEARCH_PLACEHOLDER',
  },
  OUT_OF: 'OUT_OF',
  TITLE_NAVIGATION: 'TITLE_NAVIGATION',
  LINKEDIN_PROFILE_MESSAGE: 'LINKEDIN_PROFILE_MESSAGE',
  CONTINUE: 'CONTINUE',
  CANCEL: 'CANCEL',
  LINKEDIN_DIALOG_ERROR: 'LINKEDIN_DIALOG_ERROR',
  LINKEDIN_URL: 'LINKEDIN_URL',
  TALENT_LINKEDIN_URL: 'TALENT_LINKEDIN_URL',
  SKILLS_PLACEHOLDER: 'SKILLS_PLACEHOLDER',
  KEY_ATTRIBUTES: 'KEY_ATTRIBUTES',
  STATUS_DRAFT: 'STATUS_DRAFT',
  STATUS_PUBLISHED: 'STATUS_PUBLISHED',
  POSITIONS_CREATE_NEW: {
    NAVIGATION_CURRENT: 'POSITIONS_CREATE_NEW_NAVIGATION_CURRENT',
    AVATAR_TITLE: 'AVATAR_TITLE',
    BTN_DRAFT: 'BTN_DRAFT',
    BTN_DRAFT_SAVED: 'BTN_DRAFT_SAVED',
    BTN_PUBLISH: 'BTN_PUBLISH',
    BTN_PUBLISHED: 'BTN_PUBLISHED',
    BTN_RE_PUBLISHED: 'BTN_RE_PUBLISHED',
  },
  POSITIONS_CREATE_EDIT: {
    NAVIGATION_CURRENT: 'POSITIONS_CREATE_EDIT_NAVIGATION_CURRENT',
  },
  CHOOSE_ICON: 'CHOOSE_ICON',
  INSIGHT_LABEL: 'INSIGHT_LABEL',
  INSIGHT_KEY: 'INSIGHT_KEY',
  POSITION_BASIC_INFO: {
    TITLE: 'TITLE',
    SUBTITLE: 'SUBTITLE',
    ACCOUNT_LABEL: 'ACCOUNT_LABEL',
    ACCOUNT_PLACEHOLDER: 'ACCOUNT_PLACEHOLDER',
    COMPANY_LABEL: 'COMPANY_LABEL',
    COMPANY_DEFAULT_NAME: 'COMPANY_DEFAULT_NAME',
    POSITION_TITLE: 'POSITION_TITLE',
    INTERNAL_OWNER_LABEL: 'INTERNAL_OWNER_LABEL',
    INTERNAL_OWNER_PLACEHOLDER: 'INTERNAL_OWNER_PLACEHOLDER',
    POSITION_LOCATION: 'POSITION_LOCATION',
    POSITION_REMOTE: 'POSITION_REMOTE',
    INTERNAL_USERS_TEXT_VALIDATION: 'INTERNAL_USERS_TEXT_VALIDATION',
    LEVEL_OF_EXPERIENCE: 'LEVEL_OF_EXPERIENCE',
  },
  POSITION_LOCATION: {
    X_MORE_LOCATIONS: 'POSITION_LOCATION_X_MORE_LOCATIONS',
  },
  POSITION_LOCATIONS_SECTION: {
    TITLE: 'POSITION_LOCATIONS_SECTION_TITLE',
    MILES_RADIUS_LABEL: 'MILES_RADIUS_LABEL',
    // MATCHES_BATCH_SIZE_LABEL: 'MATCHES_BATCH_SIZE_LABEL',
    // MATCHES_DAILY_LIMIT_SIZE_LABEL: 'MATCHES_DAILY_LIMIT_SIZE_LABEL',
  },
  POSITION_TIMEZONE: {
    TITLE: 'POSITION_TIMEZONE_TITLE',
    TIMEZONE_LABEL: 'POSITION_TIMEZONE_LABEL',
  },
  POSITION_COMPANY_SIZES: {
    TITLE: 'POSITION_COMPANY_SIZES_TITLE',
    LABEL: 'POSITION_COMPANY_SIZES_LABEL',
  },
  REGION_LABEL: 'REGIONS_LABEL',
  EXACT_LOCATION_LABEL: 'EXACT_LOCATION_LABEL',
  POSITION_JOB_DESCRIPTION: {
    TITLE: 'JOB_DESCRIPTION_TITLE',
    SAVED_FILE: 'JOB_DESCRIPTION_SAVED_FILE',
    SNAPSHOT: 'JOB_DESCRIPTION_SNAPSHOT',
    SOURCE: 'JOB_DESCRIPTION_SOURCE',
    LINK_PLACEHOLDER: 'JOB_DESCRIPTION_LINK_PLACEHOLDER',
  },
  POSITION_MATCH_CONSTRAINTS: {
    PLACEHOLDER: 'MATCH_CONSTRAINTS_PLACEHOLDER',
    TITLE: 'MATCH_CONSTRAINTS_TITLE',
    MINIMUM_MONTHS_OF_EXPERIENCE: 'MATCH_CONSTRAINTS_MINIMUM_MONTHS_OF_EXPERIENCE',
    MAXIMUM_MONTHS_OF_EXPERIENCE: 'MATCH_CONSTRAINTS_MAXIMUM_MONTHS_OF_EXPERIENCE',
    MAXIMUM_MONTHS_OF_EXPERIENCE_TARGET_ROLES:
      'MATCH_CONSTRAINTS_MAXIMUM_MONTHS_OF_EXPERIENCE_TARGET_ROLES',
    MINIMUM_MONTHS_OF_EXPERIENCE_TARGET_ROLES:
      'MATCH_CONSTRAINTS_MINIMUM_MONTHS_OF_EXPERIENCE_TARGET_ROLES',
    MINIMUM_MONTHS_OF_CURRENT_JOB: 'MATCH_CONSTRAINTS_MINIMUM_MONTHS_OF_CURRENT_JOB',
    TARGET_COMPANIES: 'MATCH_CONSTRAINTS_TARGET_COMPANIES',
    TARGET_LOCATION_STATE: 'MATCH_CONSTRAINTS_TARGET_LOCATION_STATE',
    TARGET_CITIES: 'MATCH_CONSTRAINTS_TARGET_CITIES',
    TARGET_CITIES_RADIUS: 'MATCH_CONSTRAINTS_TARGET_CITIES_RADIUS',
    HARDCODED_EXEMPLARS: 'MATCH_CONSTRAINTS_HARDCODED_EXEMPLARS',
    TARGET_EDUCATION_SCHOOLS: 'MATCH_CONSTRAINTS_TARGET_EDUCATION_SCHOOLS',
    COMPANY_SEMANTIC_SEARCH: 'MATCH_CONSTRAINTS_COMPANY_SEMANTIC_SEARCH',
    TALENT_SEMANTIC_SEARCH: 'MATCH_CONSTRAINTS_TALENT_SEMANTIC_SEARCH',
    COMPANY_SIZES: 'MATCH_CONSTRAINTS_COMPANY_SIZES',
    TALENT_SEMANTIC_SEARCH_REQUIREMENTS: 'TALENT_SEMANTIC_SEARCH_REQUIREMENTS',
    TARGET_JOB_TITLES: 'MATCH_CONSTRAINTS_TARGET_JOB_TITLES',
    TARGET_EDUCATION_FIELD_OF_STUDIES: 'MATCH_CONSTRAINTS_TARGET_EDUCATION_FIELD_OF_STUDIES',
    TARGET_EDUCATION_DEGREE: 'MATCH_CONSTRAINTS_TARGET_EDUCATION_DEGREE',
  },
  ACCOUNTS_PAGE_CREATE_BUTTON: 'ACCOUNTS_PAGE_CREATE_BUTTON',
  ACCOUNTS_ACTION_MENU_EDIT: 'ACCOUNTS_ACTION_MENU_EDIT',
  ACCOUNTS_ACTION_MENU_DELETE: 'ACCOUNTS_ACTION_MENU_DELETE',
  ACCOUNTS_ACTION_MENU_VIEW_POSITIONS: 'ACCOUNTS_ACTION_MENU_VIEW_POSITIONS',
  ACCOUNTS_ACTION_MENU_LOGIN_AS_ADMIN: 'ACCOUNTS_ACTION_MENU_LOGIN_AS_ADMIN',
  ACCOUNTS_TOTAL_COUNT: 'ACCOUNTS_TOTAL_COUNT',
  ACCOUNTS_TABLE_HEADER_NAME_AND_ID: 'ACCOUNTS_TABLE_HEADER_NAME_AND_ID',
  ACCOUNTS_TABLE_HEADER_ASSOCIATED_COMPANY: 'ACCOUNTS_TABLE_HEADER_ASSOCIATED_COMPANY',
  ACCOUNTS_TABLE_HEADER_SUBDOMAIN: 'ACCOUNTS_TABLE_HEADER_SUBDOMAIN',
  ACCOUNTS_TABLE_HEADER_PLAN: 'ACCOUNTS_TABLE_HEADER_PLAN',
  COMPANY_SIZE: 'COMPNAY_SIZE',
  ACCOUNTS_TABLE_HEADER_STATUS: 'ACCOUNTS_TABLE_HEADER_STATUS',
  ACCOUNTS_TABLE_HEADER_POSITIONS: 'ACCOUNTS_TABLE_HEADER_POSITIONS',
  ACCOUNTS_TABLE_HEADER_EMAIL_SENDERS: 'ACCOUNTS_TABLE_HEADER_EMAIL_SENDERS',
  ACCOUNTS_TABLE_HEADER_ATS: 'ACCOUNTS_TABLE_HEADER_ATS',
  ACCOUNTS_TABLE_HEADER_LAST_UPDATE: 'ACCOUNTS_TABLE_HEADER_LAST_UPDATE',
  ACCOUNTS_TABLE_HEADER_DATE_CREATED: 'ACCOUNTS_TABLE_HEADER_DATE_CREATED',
  TALENTS_TABLE_HEADER_NAME_AND_ID: 'TALENTS_TABLE_HEADER_NAME_AND_ID',
  TALENTS_TABLE_HEADER_JOB_TITLE: 'TALENTS_TABLE_HEADER_JOB_TITLE',
  TALENTS_TABLE_HEADER_CURRENT_COMPANY: 'TALENTS_TABLE_HEADER_CURRENT_COMPANY',
  POSITION_SKILLS: {
    LABEL: 'POSITION_SKILLS_LABEL',
    REQUIRED_LABEL: 'POSITION_SKILLS_REQUIRED_LABEL',
  },
  POSITION_COMPANY_BACKGROUND: {
    REQUIRED_LABEL: 'POSITION_SKILLS_REQUIRED_LABEL',
  },
  POSITION_ATTRIBUTES: {
    TITLE: 'POSITION_ATTRIBUTES_TITLE',
    SUBTITLE: 'POSITION_ATTRIBUTES_SUBTITLE',
    PLACEHOLDER: 'POSITION_ATTRIBUTES_PLACEHOLDER',
  },
  POSITION_VALIDATION_ERROR: {
    JOB_TITLE: 'POSITION_VALIDATION_JOB_TITLE_ERROR',
    LOCATION: 'POSITION_VALIDATION_LOCATION_ERROR',
    ACCOUNT: 'POSITION_VALIDATION_ACCOUNT_ERROR',
    URL: 'POSITION_VALIDATION_LINK_URL_ERROR',
  },
  CONTACT_INFORMATION: 'CONTACT_INFORMATION',
  CREATE_NEW_TALENT: 'CREATE_NEW_TALENT',
  SEARCH_TALENT_PLACEHOLDER: 'SEARCH_TALENT_PLACEHOLDER',
  NO_RESULTS: 'NO_RESULTS',
  RESULTS_FOUND: 'RESULTS_FOUND',
  POSITION_NAME: 'POSITION_NAME',
  MATCH_DETAILS: 'MATCH_DETAILS',
  UNPUBLISH: 'UNPUBLISH',
  PUBLISH: 'PUBLISH',
  REPUBLISH: 'REPUBLISH',
  POSITION_DELETE_DIALOG: {
    TITLE: 'POSITION_DELETE_DIALOG_TITLE',
    SUB_TITLE: 'POSITION_DELETE_DIALOG_SUB_TITLE',
    ACTION_BTN: 'POSITION_DELETE_DIALOG_ACTION_BTN',
  },
  POSITION_PUBLISH_DIALOG: {
    TITLE: 'POSITION_PUBLISH_DIALOG_TITLE',
    SUB_TITLE: 'POSITION_PUBLISH_DIALOG_SUB_TITLE',
    ACTION_BTN: 'POSITION_PUBLISH_DIALOG_ACTION_BTN',
  },
  MATCH_DELETE_DIALOG: {
    TITLE: 'MATCH_DELETE_DIALOG_TITLE',
    SUB_TITLE: 'MATCH_DELETE_DIALOG_SUB_TITLE',
    ACTION_BTN: 'MATCH_DELETE_DIALOG_ACTION_BTN',
  },
  MATCHES_DELETE_DIALOG_TITLE: 'MATCHES_DELETE_DIALOG_TITLE',
  MATCHES_DELETE_DIALOG_SUB_TITLE: 'MATCHES_DELETE_DIALOG_SUB_TITLE',
  MATCHES_DELETE_DIALOG_ACTION_BTN: 'MATCHES_DELETE_DIALOG_ACTION_BTN',
  MATCH_PUBLISH_DIALOG: {
    TITLE: 'MATCH_PUBLISH_DIALOG_TITLE',
    SUB_TITLE: 'MATCH_PUBLISH_DIALOG_SUB_TITLE',
    ACTION_BTN: 'MATCH_PUBLISH_DIALOG_ACTION_BTN',
  },
  DIALOG: {
    BTN_GO_BACK: 'POPUPS_BTN_GO_BACK',
  },
  POSITION_ERRORS: {
    DELETE: 'DELETE_POSITION',
    SAVE: 'SAVE_POSITION',
  },
  ACCOUNT_ERRORS: {
    DELETE: 'DELETE_POSITION',
  },
  DESCRIPTION_PLACEHOLDER: 'DESCRIPTION_PLACEHOLDER',
  SUBTITLE_PLACEHOLDER: 'SUBTITLE_PLACEHOLDER',
  UPDATE_CONTACT_INFO: 'UPDATE_CONTACT_INFO',
  DONE: 'DONE',
  NOTIFICATION_MESSAGE: 'NOTIFICATION_MESSAGE',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  ORDER_PLACEHOLDER: 'ORDER_PLACEHOLDER',
  TYPE_PLACEHOLDER: 'TYPE_PLACEHOLDER',
  HEADLINE_PLACEHOLDER: 'HEADLINE_PLACEHOLDER',
  DESCRIPTION_OPTIONAL_PLACEHOLDER: 'DESCRIPTION_OPTIONAL_PLACEHOLDER',
  KPI_VALUE: 'KPI_VALUE',
  FIT_OVERVIEW: 'FIT_OVERVIEW',
  INSIGHT_FULL: 'INSIGHT_FULL',
  INSIGHT_IMAGES: 'INSIGHT_IMAGES',
  INSIGHT_ELEMENT: 'INSIGHT_ELEMENT',
  INSIGHT_HEADLINE_ONLY: 'INSIGHT_HEADLINE_ONLY',
  INSIGHT_SPIDER: 'INSIGHT_SPIDER',
  POSITION_DETAILS_ACTION: {
    DELETE: 'POSITION_DETAILS_ACTION_DELETE',
    BACK_TO_DRAFT: 'POSITION_DETAILS_BACK_TO_DRAFT',
    CLOSE_POSITION: 'CLOSE_POSITION',
    OPEN_POSITION: 'OPEN_POSITION',
  },
  ACCOUNT_DELETE_DIALOG: {
    TITLE: 'ACCOUNT_DELETE_DIALOG_TITLE',
    SUB_TITLE: 'ACCOUNT_DELETE_DIALOG_SUB_TITLE',
    ACTION_BTN: 'ACCOUNT_DELETE_DIALOG_ACTION_BTN',
  },
  EDIT_TALENT_INFO: 'EDIT_TALENT_INFO',
  TALENT_INFO: 'TALENT_INFO',
  APPLY_CHANGES: 'APPLY_CHANGES',
  NEW_UPDATE_AVAILABLE: 'NEW_UPDATE_AVAILABLE',
  ACCOUNT_IS_COMPANY_MANUAL: 'ACCOUNT_IS_COMPANY_MANUAL',
  COUNTER_ACTIVITIES: 'COUNTER_ACTIVITIES',
  ENTITY_NAME: 'ENTITY_NAME',
  HISTORY_ERROR_MESSAGE_TITLE: 'HISTORY_ERROR_MESSAGE_TITLE',
  HISTORY_ERROR_MESSAGE_TEXT: 'HISTORY_ERROR_MESSAGE_TEXT',
  HISTORY_NO_RESULTS_TITLE: 'HISTORY_NO_RESULTS_TITLE',
  HISTORY_NO_RESULTS_TEXT: 'HISTORY_NO_RESULTS_TEXT',
  HISTORY_EARTH_TITLE: 'HISTORY_EARTH_TITLE',
  CLEAR: 'Clear',
  TALENT_VIEW_UPDATED_VERSION: 'TALENT_VIEW_UPDATED_VERSION',
  ACTIVITY_TYPE: 'ACTIVITY_TYPE',
  MADE_BY: 'MADE_BY',
  HISTORY_ENTITY_NAME: 'HISTORY_ENTITY_NAME',
  HISTORY_EARTH_TEXT: 'HISTORY_EARTH_TEXT',
  ACCOUNT_DELETE_CONFIRMATION: 'ACCOUNT_DELETE_CONFIRMATION',
  MATCH_PAGE_TAB_ENGAGEMENT: 'MATCH_PAGE_TAB_ENGAGEMENT',
  MATCH_PAGE_TAB_TALENT: 'MATCH_PAGE_TAB_TALENT',
  MATCH_PAGE_TAB_METADATA: 'MATCH_PAGE_TAB_METADATA',
  MATCH_ENGAGEMENT_STATUS_RESPONSE: {
    NOT_INTERESTED: 'MATCH_ENGAGEMENT_STATUS_RESPONSE_NOT_INTERESTED',
    INTERESTED: 'MATCH_ENGAGEMENT_STATUS_RESPONSE_INTERESTED',
    NO_RESPONSE: 'MATCH_ENGAGEMENT_STATUS_RESPONSE_NO_RESPONSE',
  },
  MATCH_ENGAGEMENT_EMPTY_STATE: {
    TITLE: 'MATCH_ENGAGEMENT_EMPTY_STATE_TITLE',
    BODY: 'MATCH_ENGAGEMENT_EMPTY_STATE_BODY',
  },
  MATCH_NEW_ENGAGEMENT_RECORDS_MODAL: {
    TITLE: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_TITLE',
    SAVE: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_SAVE',
    DATE_OF_ENGAGEMENT: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_DATE_OF_ENGAGEMENT',
    THROUGH_CHANNEL: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_THROUGH_CHANNEL',
    REASON_SELECTION: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_REASON_SELECTION',
    UPDATE_ENGAGEMENT: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_UPDATE_ENGAGEMENT',
    NOTE: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_INTERNAL_NOTE',
    MATCH_STATUS: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_MATCH_STATUS',
    SAVE_ERROR: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_SAVE_ERROR',
    TEXT_VALIDATION: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_TEXT_VALIDATION',
    RESPONSE_VALIDATION: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_RESPONSE_VALIDATION',
    LEAVE_IT_AS_IS: 'MATCH_NEW_ENGAGEMENT_RECORDS_MODAL_LEAVE_IT_AS_IS',
  },
  TITLE_EDIT_TEXT: 'TITLE_EDIT_TEXT',
  MATCH_ENGAGEMENT_CHANNEL: {
    PHONE: 'MATCH_ENGAGEMENT_CHANNEL_PHONE',
    EMAIL: 'MATCH_ENGAGEMENT_CHANNEL_EMAIL',
    LINKEDIN: 'MATCH_ENGAGEMENT_CHANNEL_LINKEDIN',
    OTHER: 'MATCH_ENGAGEMENT_CHANNEL_OTHER',
    SMS: 'MATCH_ENGAGEMENT_CHANNEL_SMS',
  },
  MATCH_ENGAGEMENT_STATUS_NOT_INTERESTED: {
    NOT_LOOKING_FOR_NEW_OPPORTUNITIES: 'NOT_LOOKING_FOR_NEW_OPPORTUNITIES',
    OPEN_TO_OTHER_OPPORTUNITIES: 'OPEN_TO_OTHER_OPPORTUNITIES',
    OTHER: 'MATCH_ENGAGEMENT_STATUS_NOT_INTERESTED_OTHER',
  },
  MATCH_ENGAGEMENT_STATUS_INTERESTED_REASON: 'MATCH_ENGAGEMENT_STATUS_INTERESTED_REASON',
  THIS_ENTITY: 'THIS_ENTITY',
  CREATED: 'CREATED',
  GENERIC_SAVE_CHANGES_ERROR: 'GENERIC_SAVE_CHANGES_ERROR',
  VIEW_MATCHES: 'VIEW_MATCHES',
  VIEW_ACCOUNT: 'VIEW_ACCOUNT',
  STATISTICS: {
    MATCH_TITLE: 'STATISTICS_MATCH_TITLE',
    ALL_MATCHES: 'STATISTICS_ ALL_MATCHES',
  },
  LOADING: 'LOADING',
  LOAD_MATCH_PREVIEW_ACTION: 'LOAD_MATCH_PREVIEW_ACTION',
  CREATE_NEW_MATCH_ACTION: 'CREATE_NEW_MATCH_ACTION',
  UPDATE_MATCH_ACTION: 'UPDATE_MATCH_ACTION',
  REJECT_MATCH_ACTION: 'REJECT_MATCH_ACTION',
  UPLOAD_IMAGE_ACTION: 'UPLOAD_IMAGE_ACTION',
  FAILED_TO_ACTION: 'FAILED_TO_ACTION',
  MATCH_PREVIEW: 'MATCH_PREVIEW',
  FATAL_PAGE_ERROR: 'FATAL_PAGE_ERROR',
  CANNOT_LOAD_PREVIEW_URL: 'CANNOT_LOAD_PREVIEW_URL',
  CREATE_NEW_ACCOUNT: 'CREATE_NEW_ACCOUNT',
  ACCOUNTS_ASSOCIATED_COMPANY: 'ACCOUNTS_ASSOCIATED_COMPANY',
  ACCOUNTS_ASSOCIATED_COMPANY_LOCATION: 'ACCOUNTS_ASSOCIATED_COMPANY_LOCATION',
  MANUAL_BTN_TEXT: 'MANUAL_BTN_TEXT',
  QUESTION_FIND_COMPANY: 'QUESTION_FIND_COMPANY',
  CREATE_ACCOUNT_BTN: 'CREATE_ACCOUNT_BTN',
  ACCOUNTS_NAME: 'ACCOUNTS_NAME',
  ACCOUNTS_SUBDOMAIN: 'ACCOUNTS_SUBDOMAIN',
  HOME_PAGE: {
    TITLE: 'HOME_PAGE_TITLE',
    EMPTY_TITLE: 'HOME_PAGE_EMPTY_TITLE',
    EMPTY_DESCRIPTION: 'HOME_PAGE_EMPTY_DESCRIPTION',
    TASKS: {
      TITLE: 'HOME_PAGE_TASKS_TITLE',
      FILTER_ALL: 'HOME_PAGE_FILTER_ALL',
      FILTER_OPEN: 'HOME_PAGE_FILTER_OPEN',
      UPDATED_STATUS: 'HOME_PAGE_TASKS_UPDATED_STATUS',
      ONBOARDING_COMPLETED: 'HOME_PAGE_TASKS_ONBOARDING_COMPLETED',
      CONTACT_INFO: 'HOME_PAGE_TASKS_CONTACT_INFO',
      REQUEST_MATCHES: 'HOME_PAGE_REQUEST_MATCHES',
      MATCH_FLOW_FAILED: 'HOME_PAGE_MATCH_FLOW_FAILED',
      CONTACT_INFO_AGGREGATED: 'HOME_PAGE_TASKS_CONTACT_INFO_AGGREGATED',
      ENGAGE: 'HOME_PAGE_TASKS_ENGAGE',
      ENGAGE_AGGREGATED: 'HOME_PAGE_TASKS_ENGAGE_AGGREGATED',
    },
    SIDE_STATISTICS: {
      TITLE: 'HOME_PAGE_SIDE_STATISTICS_TITLE',
    },
    STATISTICS: {
      TITLE: 'HOME_PAGE_STATISTICS_TITLE',
    },
  },
  PARTS_OF_DAY: {
    ['NIGHT' as string]: 'NIGHT',
    ['EVENING' as string]: 'EVENING',
    ['AFTERNOON' as string]: 'AFTERNOON',
    ['MORNING' as string]: 'MORNING',
  },
  ACCOUNT_LOGIN_BTN_TEXT: 'ACCOUNT_LOGIN_BTN_TEXT',
  ACCOUNT_LOGIN_SECTION_TEXT: 'ACCOUNT_LOGIN_SECTION_TEXT',
  ACCOUNT_PANEL_TITLE: 'ACCOUNT_PANEL_TITLE',
  MANUAL: 'MANUAL',
  COMPANY_SIZE_SMALL: 'COMPANY_SIZE_SMALL',
  COMPANY_SIZE_MEDIUM: 'COMPANY_SIZE_MEDIUM',
  COMPANY_SIZE_LARGE: 'COMPANY_SIZE_LARGE',
  CHANGE: 'Change',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  ACCOUNT_REQUIRED: 'ACCOUNT_REQUIRED',
  ACCOUNT_COMPANY_NAME_REQUIRED: 'ACCOUNT_COMPANY_NAME_REQUIRED',
  ACCOUNT_COMPANY_SIZE_REQUIRED: 'ACCOUNT_COMPANY_SIZE_REQUIRED',
  ACCOUNT_SUBDOMAIN_INVALID: 'ACCOUNT_SUBDOMAIN_INVALID',
  ACCOUNT_NOTIFICATION_MANUAL_MESSAGE: 'ACCOUNT_NOTIFICATION_MANUAL_MESSAGE',
  NOT_ENOUGHT_EXPERIENCE: 'NOT_ENOUGHT_EXPERIENCE',
  TALENT: 'TALENT',
  EMPTY: 'EMPTY',
  ADDED: 'ADDED',
  REMOVED: 'REMOVED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  MATCH: 'MATCH',
  POSITION: 'POSITION',
  ADD_COMPANY_TO_DB: 'COMPANY_NOT_FOUND_DB',
  COMPANY_NOT_FOUND_LINKEDIN: 'COMPANY_NOT_FOUND_LINKEDIN',
  ADD_MANUALLY: 'ADD_MANUALLY',
  NO_OPTIONS_PLACEHOLDER: 'NO_OPTIONS_PLACEHOLDER',
  SEARCHING: 'SEARCHING',
  CREATE_NEW_COMPANY: 'CREATE_NEW_COMPANY',
  COMPANY_LOGO: 'COMPANY_LOGO',
  ERROR_MESSAGE_CREATE_ACCOUNT: 'ERROR_MESSAGE_CREATE_ACCOUNT',
  ERROR_MESSAGE_GET_ACCOUNT: 'ERROR_MESSAGE_GET_ACCOUNT',
  ERROR_LOGIN_AS_ADMIN: 'ERROR_LOGIN_AS_ADMIN',
  ACCOUNTS_EDIT_ERROR_MESSAGE_UPLOAD_IMAGE: 'ACCOUNTS_EDIT_ERROR_MESSAGE_UPLOAD_IMAGE',
  COMPANY_NAME_VALIDATION: 'COMPANY_NAME_VALIDATION',
  EDUCATION_NAME_VALIDATION: 'EDUCATION_NAME_VALIDATION',
  QUOTES: {
    TITLE: 'QUOTES_TITLE',
  },
  CONFIRM: 'CONFIRM',
  FIELD_OF_STUDY: 'FIELD_OF_STUDY',
  DEGREE: 'DEGREE',
  MATCH_PROMOTE_ERROR_MESSAGE: 'MATCH_PROMOTE_ERROR_MESSAGE',
  MATCH_REJECT_ERROR_MESSAGE: 'MATCH_REJECT_ERROR_MESSAGE',
  DEFAULT_ERROR_MESSAGE: 'DEFAULT_ERROR_MESSAGE',
  PLACEHOLDER_ENTER_EMAIL: 'PLACEHOLDER_ENTER_EMAIL',
  PLACEHOLDER_ENTER_PHONE: 'PLACEHOLDER_ENTER_PHONE',
  ADD_PHONE_NUMBER: 'ADD_PHONE_NUMBER',
  ADD_EMAIL: 'ADD_EMAIL',
  GENERAL_SERVER_ERROR: 'GENERAL_SERVER_ERROR',
  CLOSED_BY: 'CLOSED_BY',
  CLOSED: 'CLOSED',
  REOPEN: 'REOPEN',
  REOPEN_POSITION_DIALOG_TITLE: 'REOPEN_POSITION_DIALOG_TITLE',
  REOPEN_POSITION_DIALOG_SUBTITLE: 'REOPEN_POSITION_DIALOG_SUBTITLE',
  REOPEN_POSITION_DIALOG_CONFIRM: 'REOPEN_POSITION_DIALOG_CONFIRM',
  CLOSE_POSITION_DIALOG_TITLE: 'CLOSE_POSITION_DIALOG_TITLE',
  CLOSE_POSITION_DIALOG_SUBTITLE: 'CLOSE_POSITION_DIALOG_SUBTITLE',
  POSITION_CANCELED: 'OTPION_CLOSE_REASON_CANCELED',
  POSITION_ALREADY_FULFILLED: 'OTPION_CLOSE_REASON_FULFILLED',
  OTPION_CLOSE_REASON_OTHER: 'OTPION_CLOSE_REASON_OTHER',
  SELECT_A_REASON: 'SELECT_A_REASON',
  PLEASE_TYPE_YOUR_YOUR_OTHER_REASON: 'PLEASE_TYPE_YOUR_YOUR_OTHER_REASON',
  RUN_SEARCH: 'RUN_SEARCH',
  ENGINE_RUNS: 'ENGINE_RUNS',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  DEGRADED: 'DEGRADED',
  CREATED_CANDIDATES: 'CREATED_CANDIDATES',
  DUPLICATE_CANDIDATES: 'DUPLICATE_CANDIDATES',
  AUTO_PUBLISH: 'AUTO_PUBLISH',
  LAST_RUN: 'LAST_RUN',
  PROGRESS_RUNNING_MESSAGE: 'PROGRESS_RUNNING',
  NEW_RUN: 'NEW_RUN',
  TALENTS: 'TALENTS',
  ENGINE_RESULTS: 'ENGINE_RESULTS',
  MATCH_ENGINE: 'MATCH_ENGINE',
  APP_MATCHES: 'APP_MATCHES',
  SIMILARITY_SCORE: 'SIMILARITY_SCORE',
  RANK: 'RANK',
  MATCH_NAME_AND_ID: 'MATCH_NAME_AND_ID',
  CURRENT_POSITION: 'CURRENT_POSITION',
  WTL_SCORE: 'WTL_SCORE',
  LAYOFF_SCORE: 'LAYOFF_SCORE',
  TALENT_NETWORK_SCORE: 'TALENT_NETWORK_SCORE',
  TALENT_SEMANTIC_SCORE: 'TALENT_SEMANTIC_SCORE',
  TALENT_SEMANTIC_ABOVE_MIN_COUNT: 'TALENT_SEMANTIC_ABOVE_MIN_COUNT',
  RUN_ID: 'RUN_ID',
  DATE_ADDED: 'DATE_ADDED',
  ENGINE_RESULTS_TABLE_RUN_ACTIONS: {
    ['PUBLISH' as string]: 'MOVE_TO_APP_AS_DRAFT',
    ['DRAFT' as string]: 'MOVE_TO_APP_AND_PUBLISH',
    ['DELETE' as string]: 'DELETE',
  },
  ENGINE_SEARCH_LOGS: 'ENGINE_SEARCH_LOGS',
  RUN_DATE: 'RUN_DATE',
  STATUS: 'STATUS',
  MATCH_FLOW_ID: 'MATCH_FLOW_ID',
  MATCH_FLOWS: 'MATCH_FLOWS',
  MATCH_F_VERSION: 'MATCH_F_VERSION',
  RUN_TIME: 'RUN_TIME',
  CLOSE: 'CLOSE',
  INPUT_PARAMETERS: 'INPUT_PARAMETERS',
  ENGINE_PARAMETERS: 'ENGINE_PARAMETERS',
  PROGRESS_STATUSES: {
    ['COMPLETED' as string]: 'COMPLETED',
    ['IN_PROGRESS' as string]: 'IN_PROGRESS',
    ['PENDING' as string]: 'PENDING',
    ['ERROR' as string]: 'ERROR',
    ['CANCELLED' as string]: 'CANCELLED',
    ['MATCH_ENGINE_COMPLETED' as string]: 'IN_PROGRESS',
    ['FAILED' as string]: 'ERROR',
    ['DEGRADED' as string]: 'DEGRADED',
  },
  NO_LOGS_NO_WORRIES: 'NO_LOGS_NO_WORRIES',
  NO_MUTCH_HAPPENING_HERE: 'NO_MUTCH_HAPPENING_HERE',
  RUN: 'RUN',
  EQUALIZER_WEIGHT: 'EQUALIZER_WEIGHT',
  WEIGHT_NAME: 'WEIGHT_NAME',
  MAX_EXPERIENCE: 'MAX_EXPERIENCE',
  MIN_EXPERIENCE: 'MIN_EXPERIENCE',
  CURRENT_JOB_TITLE: 'CURRENT_JOB_TITLE',
  LOCATION: 'LOCATION',
  CURRENT_COMPANY_NAME: 'CURRENT_COMPANY_NAME',
  CURRENT_COMPANY_SIZE_MIN: 'CURRENT_COMPANY_SIZE_MIN',
  CURRENT_COMPANY_SIZE_MAX: 'CURRENT_COMPANY_SIZE_MAX',
  COMPANY_LINKEDIN: 'COMPANY_LINKEDIN',
  SEARCH_PARAMETERS: 'SEARCH_PARAMETERS',
  LOCATION_COUNTRY: 'LOCATION_COUNTRY',
  MATCH_SELECTED: 'MATCH_SELECTED',
  MATCHES_SELECTED: 'MATCHES_SELECTED',
  ID_TITLE: 'ID_TITLE',
  RUN_ID_TITLE: 'RUN_ID_TITLE',
  PROMOTING: 'PROMOTING',
  FAILED_TO: 'FAILED_TO',
  TRIAL: 'TRIAL',
  LITE: 'LITE',
  PAID: 'PAID',
  PAID_PLAN: 'PAID_PLAN',
  OPEN_POSITION_TITLE: 'OPEN_POSITION_TITLE',
  USER_SEATS_TITLE: 'USER_SEATS_TITLE',
  TRIAL_ENDED: 'TRIAL_ENDED',
  CANCELLED: 'CANCELLED',
  CREDIT_ALLOCATIONS: {
    TITLE: 'CREDIT_ALLOCATIONS_TITLE',
    NO_ALLOCATIONS: 'CREDIT_ALLOCATIONS_NO_ALLOCATIONS',
  },
  BILLING_MENU: {
    ['ONE_YEAR' as string]: 'ONE_YEAR',
    ['MONTHLY' as string]: 'MONTHLY',
    ['QUARTERLY' as string]: 'QUARTERLY',
  },
  LEVEL_OF_EXPERIENCE: {
    [LevelOfExperienceEnum.EntryLevel]: 'ENTRY_LEVEL',
    [LevelOfExperienceEnum.StartingOut]: 'STARTING_OUT',
    [LevelOfExperienceEnum.SomewhatExperienced]: 'SOMEWHAT_EXPERIENCED',
    [LevelOfExperienceEnum.HighlyExperienced]: 'HIGHLY_EXPERIENCED',
    [LevelOfExperienceEnum.IncrediblyExperienced]: 'INCREDIBLY_EXPERIENCED',
  },
  COMPANY_SIZES: {
    [CompanySizeTierEnum.Small]: 'SMALL',
    [CompanySizeTierEnum.Medium]: 'MEDIUM',
    [CompanySizeTierEnum.Large]: 'LARGE',
    [CompanySizeTierEnum.VeryLarge]: 'VERY_LARGE',
  },
  BILLING_CYCLE: 'BILLING_CYCLE',
  PRICING_PLAN: 'PRICING_PLAN',
  PAYMENT_LINKS: 'PAYMENT_LINKS',
  PAYMENT_LINK_T2_CUSTOM: 'PAYMENT_LINK_T2_CUSTOM',
  PAYMENT_LINK_T3_CUSTOM: 'PAYMENT_LINK_T3_CUSTOM',
  PAYMENT_LINK_T4_CUSTOM: 'PAYMENT_LINK_T4_CUSTOM',
  ADD_CANDIDATES: {
    MODAL: {
      TITLE: 'ADD_CANDIDATES_MODAL_TITLE',
      INPUT_PLACEHOLDER: 'ADD_CANDIDATES_MODAL_INPUT_PLACEHOLDER',
    },
  },
  ADDING_CANDIDATES: 'ADDING_CANDIDATES',
  BASIC_PARAMETERS: 'BASIC_PARAMETERS',
  CUSTOM_MATCH_CONSTRAINTS: 'CUSTOM_MATCH_CONSTRAINTS',
  AVERAGE_TENURE_IN_ROLES: 'AVERAGE_TENURE_IN_ROLES',
  AVERAGE_TENURE_IN_COMPANIES: 'AVERAGE_TENURE_IN_COMPANIES',
  TOTAL_YEARS_OF_EXPERIENCE: 'TOTAL_YEARS_OF_EXPERIENCE',
  WEIGHTS_COMPANY_SIZE: 'WEIGHTS_COMPANY_SIZE',
  TRAJECTORY: 'TRAJECTORY',
  JOB_CATEGORY: 'JOB_CATEGORY',
  JOB_CATEGORIES_EXPERIENCE: 'JOB_CATEGORIES_EXPERIENCE',
  INDUSTRY: 'INDUSTRY',
  HARD_SKILLS: 'HARD_SKILLS',
  SOFT_SKILLS: 'SOFT_SKILLS',
  JOB_TITLE: 'JOB_TITLE',
  ACADEMIC_NOT_FOUND_LINKEDIN: 'ACADEMIC_NOT_FOUND_LINKEDIN',
  NO_OPTIONS_ACADEMIC_PLACEHOLDER: 'NO_OPTIONS_ACADEMIC_PLACEHOLDER',
  CREATE_NEW_EDUCATION_INSTITUTE: 'CREATE_NEW_EDUCATION_INSTITUTE',
  EDUCATION_INSTITUTE_LOGO: 'EDUCATION_INSTITUTE_LOGO',
  EDUCATION_INSTITUTE_NAME: 'EDUCATION_INSTITUTE_NAME',
  RUN_STATUS: 'RUN_STATUS',
  ACADEMIC_NOT_FOUND_DB: 'ACADEMIC_NOT_FOUND_DB',
  PROMOTING_STATUS: {
    ['PROMOTION_FINISHED' as string]: 'PROMOTION_FINISHED',
    ['PROMOTION_FAILED' as string]: 'PROMOTION_FAILED',
    ['PENDING_REVIEW' as string]: 'PENDING_REVIEW',
    ['PROMOTION_IN_PROGRESS' as string]: 'PROMOTION_IN_PROGRESS',
    ['PENDING_PROMOTION' as string]: 'PENDING_PROMOTION',
    ['DELETED' as string]: 'DELETED',
  },
  PENDING_PROMOTION_TEXT: 'PENDING_PROMOTION_TEXT',
  CANCEL_SEARCH: 'CANCEL_SEARCH',
  SEARCH_RUN: 'SEARCH_RUN',
  CANCELED: 'CANCELED',
  RUN_DETAILS: 'RUN_DETAILS',
  RUN_DETAILS_ID: 'RUN_DETAILS_ID',
  CHANGE_ASSOCIATED_COMPANY: 'CHANGE_ASSOCIATED_COMPANY',
  ASSOCIATED_COMPANY_LABEL: 'ASSOCIATED_COMPANY_LABEL',
  ADD_COMPANY: 'ADD_COMPANY',
  CONTACT_INFO: 'CONTACT_INFO',
  UPDATE_CONTACT_INFO_INFORMATION: 'UPDATE_CONTACT_INFO_INFORMATION',
  SEARCHING_DATABASE: 'SEARCHING_DATABASE',
  GET_CONTACT_INFO: 'GET_CONTACT_INFO',
  CONTACT_INFO_STATUS_DONE: 'CONTACT_INFO_STATUS_DONE',
  CONTACT_INFO_STATUS_ERROR: 'CONTACT_INFO_STATUS_ERROR',
  CONTACT_INFO_STATUS_NO_RESULTS: 'CONTACT_INFO_STATUS_NO_RESULTS',
  CONTACT_INFO_REQUEST: 'CONTACT_INFO_REQUEST',
  HARDCODED_EXEMPLARS: {
    SELECTED_COUNTER: 'HARDCODED_EXEMPLARS_SELECTED_COUNTER',
  },
  EMAIL_DOMAIN: 'EMAIL_DOMAIN',
  ALLOWED_WRONG_EMAIL_DOMAIN: 'ALLOWED_EMAIL_DOMAIN_REQUIRED',
  REJECT: 'REJECT',
  ACCEPT: 'ACCEPT',
  DRAFT: 'DRAFT',
  REJECT_THIS_MATCH_LABEL: 'REJECT_THIS_MATCH_LABEL',
  MATCHES_REJECT_DIALOG_TITLE: 'MATCHES_REJECT_DIALOG_TITLE',
  MATCHES_REJECT_DIALOG_SUB_TITLE: 'MATCHES_REJECT_DIALOG_SUB_TITLE',
  MATCHES_REJECT_DIALOG_ACTION_BTN: 'MATCHES_REJECT_DIALOG_ACTION_BTN',
  HARDCODE_EXEMPLAR_LINKEDIN_BROKEN_LINK_ERROR: 'HARDCODE_EXEMPLAR_LINKEDIN_BROKEN_LINK_ERROR',
  NO_RESULTS_FOR_THIS_RUN: 'NO_RESULTS_FOR_THIS_RUN',
  MATCH_RESULT: 'MATCH_RESULT',
  ALL_RUNS: 'ALL_RUNS',
  PER_RUN: 'PER_RUN',
  START_FOR: 'START_FOR',
  DECLINE_RATE: 'DECLINE_RATE',
  RELEVANCE_RATE: 'RELEVANCE_RATE',
  RESULTS: 'RESULTS',
  ENTER_JOB_TITLE: 'ENTER_JOB_TITLE',
  ENTER_KEYWORDS: 'ENTER_KEYWORDS',
  ENTER_S3_URL: 'ENTER_S3_URL',
  SIMILAR_PRIORITIZED_JOB_TITLES: 'SIMILAR_PRIORITIZED_JOB_TITLES',
  ADD_SEMANTIC_ITEM: 'ADD_SEMANTIC_ITEM',
  EXCLUDED_JOB_TITLES: 'EXCLUDED_JOB_TITLES',
  SENIORITY_TARGET_RANGE: 'SENIORITY_TARGET_RANGE',
  TARGET_LOCATIONS: 'TARGET_LOCATIONS',
  ENTER_INDUSTRY_NAME: 'ENTER_INDUSTRY_NAME',
  COMPANY_BLOCK_LIST: 'COMPANY_BLOCK_LIST',
  COMPANY_ALLOW_LIST: 'COMPANY_ALLOW_LIST',
  ENTER_COMPANY_LINKEDIN_URL: 'ENTER_COMPANY_LINKEDIN_URL',
  ENTER_FIELD_OF_STUDY: 'ENTER_FIELD_OF_STUDY',
  MINIMUM: 'MINIMUM',
  MAXIMUM: 'MAXIMUM',
  MONTHS: 'MONTHS',
  COMPANY_SEMANTIC_SEARCH_TEXT_INPUT_LABEL: 'COMPANY_SEMANTIC_SEARCH_TEXT_INPUT_LABEL',
  COMPANY_SEMANTIC_SEARCH_SCORE_THRESHOLD_INPUT_LABEL: 'COMPANY_SEMANTIC_SEARCH_SCORE_THRESHOLD_INPUT_LABEL',
  TALENT_SEMANTIC_SEARCH_TEXT_INPUT_LABEL: 'TALENT_SEMANTIC_SEARCH_TEXT_INPUT_LABEL',
  TALENT_SEMANTIC_SEARCH_SORT_WEIGHT_INPUT_LABEL: 'TALENT_SEMANTIC_SEARCH_SORT_WEIGHT_INPUT_LABEL',
  INCLUDE_VERBOSE_LEVEL: 'INCLUDE_VERBOSE_LEVEL',
  INCLUDE_VERBOSE_LEVEL_DESCRIPTION: 'INCLUDE_VERBOSE_LEVEL_DESCRIPTION',
  IGNORE_TITLES_FILTER: 'IGNORE_TITLE_FILTER',
  IGNORE_TITLES_FILTER_DESCRIPTION: 'IGNORE_TITLES_FILTER_DESCRIPTION',
  POTENTIAL_CANDIDATES_S3_URL: 'POTENTIAL_CANDIDATES_S3_URL',
  MATCH_ENGINE_STATISTICS_ERROR: 'MATCH_ENGINE_STATISTICS_ERROR',
  DISCONNECT_ATS: 'DISCONNECT_ATS',
  DISCONNECT_ATS_CONFIRMATION_TITLE: 'DISCONNECT_ATS_CONFIRMATION_TITLE',
  DISCONNECT_ATS_CONFIRMATION_MESSAGE: 'DISCONNECT_ATS_CONFIRMATION_MESSAGE',
  DISCONNECT_ATS_SUCCESS: 'DISCONNECT_ATS_SUCCESS',
  ATS_INTEGRATION: 'ATS_INTEGRATION',
  ATS_LINKED_AT: 'ATS_LINKED_AT',

  OUTREACH_TRIAL_OVERRIDE_LABEL: 'OUTREACH_TRIAL_OVERRIDE_LABEL',
  OUTREACH_TRIAL_OVERRIDE_HELPER_DISABLED: 'OUTREACH_TRIAL_OVERRIDE_HELPER_DISABLED',
  OUTREACH_TRIAL_OVERRIDE_HELPER_LOCKED: 'OUTREACH_TRIAL_OVERRIDE_HELPER_LOCKED',
  OUTREACH_TRIAL_OVERRIDE_CONFIRM_TITLE: 'OUTREACH_TRIAL_OVERRIDE_CONFIRM_TITLE',
  OUTREACH_TRIAL_OVERRIDE_CONFIRM_BODY: 'OUTREACH_TRIAL_OVERRIDE_CONFIRM_BODY',
  OUTREACH_TRIAL_OVERRIDE_CONFIRM_OK: 'OUTREACH_TRIAL_OVERRIDE_CONFIRM_OK',
  OUTREACH_TRIAL_OVERRIDE_CONFIRM_CANCEL: 'OUTREACH_TRIAL_OVERRIDE_CONFIRM_CANCEL',
  LAYOUT_REFERRALS_TITLE: 'LAYOUT_REFERRALS_TITLE',
  REFERRALS: {
    FILTER_STATUS: 'REFERRALS_FILTER_STATUS',
    FILTER_ELIGIBILITY: 'REFERRALS_FILTER_ELIGIBILITY',
    FILTER_ALL: 'REFERRALS_FILTER_ALL',
    FILTER_UNLINKED: 'REFERRALS_FILTER_UNLINKED',
    FILTER_PAYOUT_FAILED: 'REFERRALS_FILTER_PAYOUT_FAILED',
    FILTER_NO_HUBSPOT_STATUS: 'REFERRALS_FILTER_NO_HUBSPOT_STATUS',
    TAX_REPORT_BUTTON: 'REFERRALS_TAX_REPORT_BUTTON',
    TABLE_HEADER_REFERRER: 'REFERRALS_TABLE_HEADER_REFERRER',
    TABLE_HEADER_FRIEND_COMPANY: 'REFERRALS_TABLE_HEADER_FRIEND_COMPANY',
    TABLE_HEADER_CREATED: 'REFERRALS_TABLE_HEADER_CREATED',
    TABLE_HEADER_PATH: 'REFERRALS_TABLE_HEADER_PATH',
    TABLE_HEADER_STATUS: 'REFERRALS_TABLE_HEADER_STATUS',
    TABLE_HEADER_ELIGIBILITY: 'REFERRALS_TABLE_HEADER_ELIGIBILITY',
    TABLE_HEADER_LINKED_ACCOUNT: 'REFERRALS_TABLE_HEADER_LINKED_ACCOUNT',
    TABLE_HEADER_REWARDS: 'REFERRALS_TABLE_HEADER_REWARDS',
    TABLE_HEADER_POSITION: 'REFERRALS_TABLE_HEADER_POSITION',
    EMPTY: 'REFERRALS_EMPTY',
    LOAD_ERROR: 'REFERRALS_LOAD_ERROR',
    ACTION_ERROR: 'REFERRALS_ACTION_ERROR',
    EMAIL_INTRO: 'REFERRALS_EMAIL_INTRO',
    NOT_LINKED: 'REFERRALS_NOT_LINKED',
    PAYING_OUTSIDE_STRIPE: 'REFERRALS_PAYING_OUTSIDE_STRIPE',
    NO_PATH: 'REFERRALS_NO_PATH',
    OVERRIDDEN: 'REFERRALS_OVERRIDDEN',
    MILESTONE: 'REFERRALS_MILESTONE',
    FALLBACK: 'REFERRALS_FALLBACK',
    POSITION_UNTIL: 'REFERRALS_POSITION_UNTIL',
    POSITION_ONGOING: 'REFERRALS_POSITION_ONGOING',
    POSITION_ENDED: 'REFERRALS_POSITION_ENDED',
    ACTION_OVERRIDE_ELIGIBILITY: 'REFERRALS_ACTION_OVERRIDE_ELIGIBILITY',
    ACTION_RECHECK_ELIGIBILITY: 'REFERRALS_ACTION_RECHECK_ELIGIBILITY',
    ACTION_LINK_ACCOUNT: 'REFERRALS_ACTION_LINK_ACCOUNT',
    ACTION_CHANGE_LINKED_ACCOUNT: 'REFERRALS_ACTION_CHANGE_LINKED_ACCOUNT',
    ACTION_UNLINK_ACCOUNT: 'REFERRALS_ACTION_UNLINK_ACCOUNT',
    ACTION_SET_PAYING_OUTSIDE_STRIPE: 'REFERRALS_ACTION_SET_PAYING_OUTSIDE_STRIPE',
    ACTION_CLEAR_PAYING_OUTSIDE_STRIPE: 'REFERRALS_ACTION_CLEAR_PAYING_OUTSIDE_STRIPE',
    ACTION_QUALIFY: 'REFERRALS_ACTION_QUALIFY',
    ACTION_RESEND_REWARD: 'REFERRALS_ACTION_RESEND_REWARD',
    ACTION_REISSUE_REWARD: 'REFERRALS_ACTION_REISSUE_REWARD',
    ACTION_END_POSITION: 'REFERRALS_ACTION_END_POSITION',
    ACTION_FORCE_SEND_REWARD: 'REFERRALS_ACTION_FORCE_SEND_REWARD',
    FORCE_SEND_DIALOG_TITLE: 'REFERRALS_FORCE_SEND_DIALOG_TITLE',
    FORCE_SEND_DIALOG_SUB_TITLE: 'REFERRALS_FORCE_SEND_DIALOG_SUB_TITLE',
    FORCE_SEND_DIALOG_BTN: 'REFERRALS_FORCE_SEND_DIALOG_BTN',
    OVERRIDE_DIALOG_TITLE: 'REFERRALS_OVERRIDE_DIALOG_TITLE',
    OVERRIDE_DIALOG_SUB_TITLE: 'REFERRALS_OVERRIDE_DIALOG_SUB_TITLE',
    OVERRIDE_DIALOG_REASON: 'REFERRALS_OVERRIDE_DIALOG_REASON',
    OVERRIDE_DIALOG_BTN: 'REFERRALS_OVERRIDE_DIALOG_BTN',
    LINK_DIALOG_TITLE: 'REFERRALS_LINK_DIALOG_TITLE',
    LINK_DIALOG_SUB_TITLE: 'REFERRALS_LINK_DIALOG_SUB_TITLE',
    LINK_DIALOG_SEARCH: 'REFERRALS_LINK_DIALOG_SEARCH',
    LINK_DIALOG_BTN: 'REFERRALS_LINK_DIALOG_BTN',
    UNLINK_DIALOG_TITLE: 'REFERRALS_UNLINK_DIALOG_TITLE',
    UNLINK_DIALOG_SUB_TITLE: 'REFERRALS_UNLINK_DIALOG_SUB_TITLE',
    UNLINK_DIALOG_BTN: 'REFERRALS_UNLINK_DIALOG_BTN',
    QUALIFY_DIALOG_TITLE: 'REFERRALS_QUALIFY_DIALOG_TITLE',
    QUALIFY_DIALOG_SUB_TITLE: 'REFERRALS_QUALIFY_DIALOG_SUB_TITLE',
    QUALIFY_DIALOG_BTN: 'REFERRALS_QUALIFY_DIALOG_BTN',
    RESEND_DIALOG_TITLE: 'REFERRALS_RESEND_DIALOG_TITLE',
    RESEND_DIALOG_SUB_TITLE: 'REFERRALS_RESEND_DIALOG_SUB_TITLE',
    RESEND_DIALOG_SAME_EMAIL: 'REFERRALS_RESEND_DIALOG_SAME_EMAIL',
    RESEND_DIALOG_NEW_EMAIL: 'REFERRALS_RESEND_DIALOG_NEW_EMAIL',
    RESEND_DIALOG_EMAIL_LABEL: 'REFERRALS_RESEND_DIALOG_EMAIL_LABEL',
    RESEND_DIALOG_EMAIL_INVALID: 'REFERRALS_RESEND_DIALOG_EMAIL_INVALID',
    RESEND_DIALOG_BTN: 'REFERRALS_RESEND_DIALOG_BTN',
    REDIRECT_DIALOG_BTN: 'REFERRALS_REDIRECT_DIALOG_BTN',
    REISSUE_DIALOG_TITLE: 'REFERRALS_REISSUE_DIALOG_TITLE',
    REISSUE_DIALOG_SUB_TITLE: 'REFERRALS_REISSUE_DIALOG_SUB_TITLE',
    REISSUE_DIALOG_SAME_EMAIL: 'REFERRALS_REISSUE_DIALOG_SAME_EMAIL',
    REISSUE_DIALOG_NEW_EMAIL: 'REFERRALS_REISSUE_DIALOG_NEW_EMAIL',
    REISSUE_DIALOG_BTN: 'REFERRALS_REISSUE_DIALOG_BTN',
    END_POSITION_DIALOG_TITLE: 'REFERRALS_END_POSITION_DIALOG_TITLE',
    END_POSITION_DIALOG_SUB_TITLE: 'REFERRALS_END_POSITION_DIALOG_SUB_TITLE',
    END_POSITION_DIALOG_BTN: 'REFERRALS_END_POSITION_DIALOG_BTN',
    TAX_REPORT_DIALOG_TITLE: 'REFERRALS_TAX_REPORT_DIALOG_TITLE',
    TAX_REPORT_DIALOG_SUB_TITLE: 'REFERRALS_TAX_REPORT_DIALOG_SUB_TITLE',
    TAX_REPORT_DIALOG_YEAR: 'REFERRALS_TAX_REPORT_DIALOG_YEAR',
    TAX_REPORT_DIALOG_BTN: 'REFERRALS_TAX_REPORT_DIALOG_BTN',
    TAX_REPORT_ERROR: 'REFERRALS_TAX_REPORT_ERROR',
    ACCOUNT_PANEL_TITLE: 'REFERRALS_ACCOUNT_PANEL_TITLE',
    ACCOUNT_PANEL_COUNT: 'REFERRALS_ACCOUNT_PANEL_COUNT',
    ACCOUNT_PANEL_POSITION: 'REFERRALS_ACCOUNT_PANEL_POSITION',
    ACCOUNT_PANEL_REFERRED_BY: 'REFERRALS_ACCOUNT_PANEL_REFERRED_BY',
    ACCOUNT_PANEL_LOAD_ERROR: 'REFERRALS_ACCOUNT_PANEL_LOAD_ERROR',
    UNKNOWN_COMPANY: 'REFERRALS_UNKNOWN_COMPANY',
    UNKNOWN_REFERRER: 'REFERRALS_UNKNOWN_REFERRER',
    PROGRAM_DISABLED: 'REFERRALS_PROGRAM_DISABLED',
    HUBSPOT_UNAVAILABLE: 'REFERRALS_HUBSPOT_UNAVAILABLE',
    FORCE_SEND_OUTCOME_WITH_REASON: 'REFERRALS_FORCE_SEND_OUTCOME_WITH_REASON',
  },
  REFERRAL_STATUSES: {
    [ReferralStatus.Created]: 'REFERRAL_STATUSES_CREATED',
    [ReferralStatus.NotQualified]: 'REFERRAL_STATUSES_NOT_QUALIFIED',
    [ReferralStatus.Qualified]: 'REFERRAL_STATUSES_QUALIFIED',
    [ReferralStatus.Paid]: 'REFERRAL_STATUSES_PAID',
    [ReferralStatus.Ended]: 'REFERRAL_STATUSES_ENDED',
  },
  REFERRAL_ELIGIBILITIES: {
    [ReferralEligibility.Eligible]: 'REFERRAL_ELIGIBILITIES_ELIGIBLE',
    [ReferralEligibility.Ineligible]: 'REFERRAL_ELIGIBILITIES_INELIGIBLE',
  },
  REFERRAL_INELIGIBILITY_REASONS: {
    [ReferralIneligibilityReason.CurrentCustomer]: 'REFERRAL_INELIGIBILITY_REASONS_CURRENT_CUSTOMER',
    [ReferralIneligibilityReason.RecentSalesContact]: 'REFERRAL_INELIGIBILITY_REASONS_RECENT_SALES_CONTACT',
    [ReferralIneligibilityReason.Duplicate]: 'REFERRAL_INELIGIBILITY_REASONS_DUPLICATE',
    [ReferralIneligibilityReason.SelfReferral]: 'REFERRAL_INELIGIBILITY_REASONS_SELF_REFERRAL',
    [ReferralIneligibilityReason.UnknownReferrer]: 'REFERRAL_INELIGIBILITY_REASONS_UNKNOWN_REFERRER',
  },
  REFERRAL_PATHS: {
    [ReferralPath.GiftCard]: 'REFERRAL_PATHS_GIFT_CARD',
    [ReferralPath.Position]: 'REFERRAL_PATHS_POSITION',
  },
  REFERRAL_REWARD_STATUSES: {
    [ReferralRewardStatus.AwaitingPath]: 'REFERRAL_REWARD_STATUSES_AWAITING_PATH',
    [ReferralRewardStatus.Processing]: 'REFERRAL_REWARD_STATUSES_PROCESSING',
    [ReferralRewardStatus.Sent]: 'REFERRAL_REWARD_STATUSES_SENT',
    [ReferralRewardStatus.DeliveryFailed]: 'REFERRAL_REWARD_STATUSES_DELIVERY_FAILED',
    [ReferralRewardStatus.PositionGranted]: 'REFERRAL_REWARD_STATUSES_POSITION_GRANTED',
    [ReferralRewardStatus.Canceled]: 'REFERRAL_REWARD_STATUSES_CANCELED',
  },
  REFERRAL_FALLBACK_REASONS: {
    [ReferralRewardFallbackReason.NoCap]: 'REFERRAL_FALLBACK_REASONS_NO_CAP',
    [ReferralRewardFallbackReason.ReferrerGone]: 'REFERRAL_FALLBACK_REASONS_REFERRER_GONE',
  },
  REFERRAL_FORCE_SEND_OUTCOMES: {
    [ReferralForceSendOutcome.Sent]: 'REFERRAL_FORCE_SEND_OUTCOMES_SENT',
    [ReferralForceSendOutcome.HeldDisabled]: 'REFERRAL_FORCE_SEND_OUTCOMES_HELD_DISABLED',
    [ReferralForceSendOutcome.HeldNotConfigured]: 'REFERRAL_FORCE_SEND_OUTCOMES_HELD_NOT_CONFIGURED',
    [ReferralForceSendOutcome.HeldBreaker]: 'REFERRAL_FORCE_SEND_OUTCOMES_HELD_BREAKER',
    [ReferralForceSendOutcome.Failed]: 'REFERRAL_FORCE_SEND_OUTCOMES_FAILED',
    [ReferralForceSendOutcome.NotIssuable]: 'REFERRAL_FORCE_SEND_OUTCOMES_NOT_ISSUABLE',
  },
  REFERRAL_POSITION_END_REASONS: {
    [ReferralPositionEndReason.TermElapsed]: 'REFERRAL_POSITION_END_REASONS_TERM_ELAPSED',
    [ReferralPositionEndReason.ReferredStoppedPaying]: 'REFERRAL_POSITION_END_REASONS_REFERRED_STOPPED_PAYING',
    [ReferralPositionEndReason.Manual]: 'REFERRAL_POSITION_END_REASONS_MANUAL',
  },
};
export default STRING_KEYS;
